module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/past-projects/Storiestogether@2x-e4c69fcaa4ce3bb473a53a8e1c377124.jpg";